import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Button, Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AnchorLink from 'react-anchor-link-smooth-scroll';

function TinToneShade() {
    window.scrollTo(0, 0);
    const [focus, setFocus] = React.useState(false);
    return (
        <div>
            <Helmet>

                <title>Transforming Premium Interiors: 400% Growth in Revenue for Tint Tone & Shade</title>
                <meta name="description" content="" />
                <link rel="canonical" href="https://anbluxury.com/case-studies/adani-realty-case-study.html" />

            </Helmet>
            {/* first fold */}
            <div className="casestudy">
                <div className="box padmmdt padmmdb">

                    <Container>

                        <p className="text-left p1 pdl10"> <span class="spcase">TIN TONE</span> & SHADE</p>
                    </Container>

                    <Container fluid className="padbsmt padbsmb">
                        <Row>
                            <Col lg="2"></Col>
                            <Col lg="8">
                                <div className="circleboxfirst circleboxfirst-relative  padssmb">
                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="roundbx" width="30%" alt="" />

                                    <div className="boxcentered tpfold">
                                        <h4 className="d-none d-sm-block cuspn"> <span class=""> Transforming Premium Interiors: </span><br />   400% Growth in Revenue for Tint Tone & Shade  <br /></h4>
                                        <h4 className="d-block d-sm-none"> <span class="cuspn"> Transforming Premium Interiors: </span>  <br />   400% Growth in Revenue for Tint Tone & Shade  <br /></h4>

                                    </div>
                                </div>
                            </Col>
                            <Col lg="2"></Col>
                        </Row>
                    </Container>
                </div>
            </div>
            {/* The brand fold */}
            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>BRAND</strong>  </p>
                            <p className="marbmdt mbt20 ">
                                Tint Tone & Shade (TT&S) is a premium interior design studio known for creating refined, deeply personalised, and thoughtfully curated living spaces. With a philosophy rooted in balance, aesthetics, and craftsmanship, TT&S blends global design sensibilities with modern Indian functionality.
                            </p>
                            <p>They are recognized for:</p>
                            <p className="">
                                1. Bespoke interior design solutions
                            </p>
                            <p className="">
                                2. Premium material curation & meticulous attention to detail
                            </p>
                            <p className="">
                                3. A design-first approach backed by strong execution capability
                            </p>
                            <br></br>
                            <br></br>
                        </Col>

                        <Col lg={{ span: 5 }} md={{ span: 4 }} sm={{ span: 12 }} xs={{ span: 12 }} className="offset-lg-1 mbpdr15">
                            <br></br>
                            <br></br>
                            <br></br>

                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/tin-tone/brand.png`} width="100%" height="100%" className="img-fluid text-right" />
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* The opportunity */}


            <div id="letsdo" className="seoapproach bgbl padmmdt padmmdb ">
                <Container>

                    <Row>
                        <Col sm={12}>
                            <p className="text-center p1 mrg30 " > <span class="spcase">THE</span> <strong>CHALLENGE</strong>  </p>
                        </Col>
                        <Col md={2} lg={2}></Col>
                        <Col md={8} lg={8}>
                            <br></br>
                            <br></br>
                            <p style={{ textAlign: 'center' }}>Despite having exceptional design capabilities and strong client satisfaction, TT&S struggled with scaling their digital discovery and generating consistent, high-quality enquiries.</p>
                            <br></br>
                            <br></br>
                        </Col>
                        <Col md={2} lg={2}></Col>

                    </Row>

                    <div className="appbox padssmb d-none d-sm-block">
                        <img src={`${process.env.PUBLIC_URL}/img/approach2.png`} className="imgwidt img-fluid" alt="" />
                        <div className="top-left">
                            <h4><strong> Inbound </strong><br /> <i>Leads </i></h4>
                            <p>Low inbound leads despite strong work quality</p>
                        </div>

                        <div className="top-right">
                            <h4><strong>Minimal,  </strong><br /> <i>Reach</i></h4>
                            <p>Difficulty reaching high-intent luxury homeowners</p>
                        </div>

                        <div className="bottom-left">
                            <h4> <strong>Lead Nurturing</strong><br /> <i>System</i></h4>
                            <p>No structured digital funnel or lead nurturing system</p>
                        </div>


                        <div className="bottom-right">
                            <h4><strong>Brand </strong><br /> <i>Differentiation</i></h4>
                            <p>Limited brand differentiation in a crowded interior design market</p>
                        </div>
                        <div className="centered"><h1>The <span>Challenge</span></h1></div>
                    </div>

                    <div className="appbox  padssmb d-block d-sm-none">
                        <h1>The <span>Challenge</span></h1> <br />

                        <h4><strong> Inbound </strong><br /> <i>Leads </i></h4>
                        <p>Low inbound leads despite strong work quality</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Minimal  </strong><br /> <i>Reach</i></h4>
                        <p>Difficulty reaching high-intent luxury homeowners</p>

                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Lead Nurturing</strong><br /> <i>System</i></h4>
                        <p>No structured digital funnel or lead nurturing system</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Brand </strong><br /> <i>Differentiation</i></h4>
                        <p>Limited brand differentiation in a crowded interior design market</p>
                    </div>


                    <Row>
                        <Col md={2} lg={2}></Col>
                        <Col md={8} lg={8}>
                            <br></br>
                            <br></br>
                            <p style={{ textAlign: 'center' }}>TT&S partnered with A&B to build a sustainable lead engine, strengthen brand positioning, and create a strong premium digital identity.</p>
                        </Col>
                        <Col md={2} lg={2}></Col>
                    </Row>

                </Container>
                {/* <img src={`${process.env.PUBLIC_URL}/img/approach.png`} className="img-fluid" /> */}
            </div>


            <div className="bgbl casestudy">
                <Container>
                    <Row>
                        <Col sm={12}>
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong style={{ color: '#fff' }}>PROCESS</strong>  </p>
                        </Col>
                    </Row>
                    <Process />
                </Container>

            </div>

            <div className="lgbox  problem padbxsb">
                <Container fluid className="tpfold ">
                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>IMPACT</strong> </p>
                        </Col>
                        <Row>
                            <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                                <div id="iwantto" className="seomatters casestudyimpacts bgb">
                                    <Container className="padbmdt padbmdb">
                                        <p>Our partnership with TT&S delivered a remarkable transformation in their business and lead pipeline:</p>
                                        <br></br>
                                        <br></br>
                                        <Row className="padsmdb">
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{ fontSize: 20 }} className="">400%</h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'><strong>growth in revenue,</strong> driven by high-value, luxury projects</p><br />
                                            </Col>
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{ fontSize: 20 }} className="">262%</h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'><strong>increase in lead-to-deal conversion,</strong> ensuring more enquiries turned into confirmed projects</p><br />
                                            </Col>
                                            <Col lg="4" md="4" sm="4">
                                                <div className="circleboxfirst circleboxfirst-relative  padssmb pdtb20">
                                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="servicescirbox" width="40%" alt="" />
                                                    <div className="boxcentered">
                                                        <h1 style={{ fontSize: 20 }} className="">125%</h1>
                                                    </div>
                                                </div>
                                                <p className='impact-text'><strong>improvement in deal-to-completion conversion,</strong>  reflecting smoother project onboarding and higher client satisfaction</p><br />
                                            </Col>


                                        </Row>
                                        
                                        <p>Through strategic targeting, brand repositioning, and optimized lead management, TT&S now enjoys a <strong>steady flow of high-quality luxury leads</strong> and a <strong>robust, scalable pipeline</strong> that aligns with their premium positioning.</p>
<br></br>
                                        <br></br>
                                        <AnchorLink href="" className="btn btn-seo" >Let's Get More Sales </AnchorLink>

                                    </Container>
                                </div>
                            </Col>
                        </Row>
                    </Row>

                </Container>
            </div>

            <div className="lgbox build endbox">
                <Container fluid className="pdlr0">
                    <Row className="text-left  mglr0">

                        <Col lg="6" sm="6" xs="12">
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>
                                <Row className="marssmt marssmb mglr0">

                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/isaia.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">ISAIA </h4>
                                        <p>Store Footfalls increased by 100% in 4 months </p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>

                        <Col lg="6" sm="6" xs="12" className="bgbl " >
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>
                                <Row className="marssmt marssmb mglr0">
                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/saundh.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">Saundh </h4>
                                        <p>5X Improvement in E-Commerce Conversion Rate.</p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    )
}
export default TinToneShade;

function Process() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    adaptiveHeight: true,
                }
            },],
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    adaptiveHeight: false,
                }
            },]
    };
    const next = () => {
        Slider.current.slickNext();
    }
    const previous = () => {
        Slider.current.slickPrev();
    }
    return (
        // <Container fluid className="reasons padslgt padslgb casestudy ">
        <Container fluid className="reasons padslgb casestudy ">
            <Row>
                <Col lg="10" className="offset-lg-1">
                    <Slider {...settings}>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >

                                    <h2 className="padt190"><span>Brand Repositioning</span></h2>
                                    <h3 className=" padmsmb">Redefined TT&S’ digital identity with a premium, editorial design language, bespoke craftsmanship, and signature aesthetics to stand out from mass-market interior firms.</h3>

                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/tin-tone/process_ladder_1.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>High-Intent Lead Generation</span></h2>
                                    <h3 className=" padmsmb"> Built a performance-driven funnel across Meta and Google targeting luxury homeowners, new buyers, and NRIs, using conversion-focused creatives and keyword clusters around luxury interiors and turnkey projects.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/tin-tone/process_ladder_2.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Precision Targeting</span></h2>
                                    <h3 className=" padmsmb"> Mapped luxury neighborhoods and high-value zones, identifying purchase behavior and renovation cycles to build high-quality micro-segments.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/tin-tone/process_ladder_3.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Lead Handling & Sales Enablement</span></h2>
                                    <h3 className=" padmsmb"> Implemented WhatsApp automation, structured lead routing, follow-up templates, and a qualification framework to prioritize high-value enquiries and deliver a premium experience.</h3>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/tin-tone/process_ladder_4.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                    </Slider>
                </Col>
            </Row>
        </Container>
    );
}